import { render } from "./discussion-v1.vue?vue&type=template&id=3070790a&scoped=true"
import script from "./discussion-v1.vue?vue&type=script&lang=js"
export * from "./discussion-v1.vue?vue&type=script&lang=js"

import "./discussion-v1.vue?vue&type=style&index=0&id=3070790a&lang=sass&scoped=true"

import exportComponent from "../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3070790a"]])

export default __exports__